export * from '@primeuix/themes/lara/tabs';
export { default } from '@primeuix/themes/lara/tabs';
